import { createApolloProvider } from '@vue/apollo-option';
import apolloClient from './client';

export default createApolloProvider({
  defaultClient: apolloClient,
});
